@if (isLoading) {
  <div id="spinner">
    <mat-progress-spinner class="mat-spinner-color" mode="indeterminate"></mat-progress-spinner>
  </div>
}

<div class="container">
  <!-- Table content -->
  <custom-table [tableData]="allMappings"
    [tableColumns]="tableColumns"
    [isLoading]="isLoading"
    [tableTitle]="'Mappings'"
    [tableActions]="tableActions"
    [moduleType]="'usersettings'"
    [pageType]="'attribute-mapping'"
    isFilterPresent="true"
    hideTableTitle="true"
    [filterAttributes]="filterAttributes"
    (toogleEmitter)="updateStatus($event, 'active')"
    (rowAction)="rowAction($event)"
    (tableActionEmitter)="openMappingPopup()">
  </custom-table>
</div>

<!------------------------------------------ Add Mapping popup ------------------------------------------------------>
<div class="modal fade" id="AddMappingPopup" role="dialog" tabindex="-1" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-lg">
    <div class="modal-content">
      <div class="modal-header text-center">
        <h3 id="hdrImageTitle" class="modal-title">Add Data Mapping</h3>
        <button type="button" class="close float-right" (click)="closeMappingPopup()" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>

      <!-- Mapping Name Field -->
      <div class="col-12 mt-3 mb-3">
        <label for="mappingName"><strong>Mapping Name</strong> <span class="text-danger">*</span></label>
        <input id="mappingName" type="text" class="form-control" placeholder="Enter a name for this mapping"
          [(ngModel)]="mappingName" [ngModelOptions]="{standalone: true}" required />
        </div>

        <div class="modal-body mapping-manager">
          <div class="row h-100">

            <!-- Module Selector -->
            <div class="col-12 main-menu-nav mb-3">
              <div class="d-flex flex-wrap">
                @for (module of modules; track module) {
                  <div
                    class="menu-item"
                    [class.active]="activeModule === module"
                    (click)="setActiveModule(module)">
                    {{ module }}
                  </div>
                }
              </div>
            </div>

            <!-- Match the following style -->
            @if (activeModule) {
              <div class="col-12">
                <h5 class="mb-3">Map Attributes for {{ activeModule }}</h5>
                <table class="table table-bordered align-middle">
                  <thead class="thead-light">
                    <tr>
                      <th style="width: 40%">Internal Attribute</th>
                      <th style="width: 60%">External Attribute</th>
                    </tr>
                  </thead>
                  <tbody>
                    @for (attr of getOurAttributesForModule(activeModule); track attr) {
                      <tr>
                        <td>
                          {{ attr.displayName }}
                          @if (attr.optional) {
                            <span class="text-muted small">(optional)</span>
                          }
                          @if (!attr.optional) {
                            <span class="text-danger">*</span>
                          }
                        </td>
                        <td>
                          <input
                            type="text"
                            class="form-control"
                            [placeholder]="'e.g. external_' + attr.label"
                            [(ngModel)]="mappings[activeModule][attr.key]"
                            [ngModelOptions]="{standalone: true}"
                            [required]="!attr.optional" />
                          </td>
                        </tr>
                      }
                    </tbody>
                  </table>
                  <div class="mt-2 small text-muted">
                    Fields marked <span class="text-danger">*</span> are required.
                  </div>
                </div>
              }

              <!-- Footer -->
              <div class="modal-footer">
                <button type="button" class="btn" (click)="closeMappingPopup()">Cancel</button>
                <button
                  type="button"
                  class="btn btn-success"
                  (click)="saveMappings()"
                  [disabled]="!mappingName || !activeModule || !isModuleValid(activeModule)">
                  Save
                </button>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>



